import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent { }



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/app.component.ts